<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'SISTEMAS.LBL_SISTEMAS' | translate}}</h1>
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-6 lg:col-6">
    <button type="button" pButton icon="fa fa-plus" (click)="crear()" *ngIf="menu.agregar"
            label="{{ 'BTN_AGREGAR' | translate}}"></button>
  </div>
  <div class="col-12 md:col-6 lg:col-6">
    <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
           (input)="dt.filterGlobal($event.target.value, 'contains')" [maxlength]="20"
           [(ngModel)]="busqueda" (change)="setBusqueda()">
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" [loading]="carTabla" #dt
             [value]="lisSistemas" selectionMode="single" dataKey="idSistema"
             [paginator]="true" [rows]="10"  paginatorPosition="bottom">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td>{{row.id}}</td>
          <td>{{row.codigo}}</td>
          <td>{{row.nombreSistema}}</td>
          <td class="table-break">{{row.descripcionCorta}}<a (click)="mostrarDescripcion(row)" *ngIf="row.mostrarDescripcion">...</a></td>
          <td class="table-break">{{row.token}}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorCreacion" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorConsulta" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorActualizacion" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                      title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                      (click)="editar(row)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ 'MSG_NOHAYREGISTROS' | translate}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-dialog header="{{ 'SISTEMAS.LBL_DESCRIPCION' | translate}}" [(visible)]="mosDescripcion" [contentStyle]="{'width':'600px'}" modal="true"
          *ngIf="mosDescripcion">
  <div class="grid">
    <div class="col-12 lg:col-12 md:col-12">
      {{descripcion}}
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
              pButton (click)="cerrarDescripcion()"></button>
    </div>
  </div>
</p-dialog>
